import { Button, Modal } from "@salesapp/ui";

export function DisqualifyLeadModal({
  open,
  comment,
  onCommentChange,
  onCancel,
  onConfirm,
  saving = false,
}: {
  open: boolean;
  comment: string;
  onCommentChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  saving?: boolean;
}) {
  return (
    <Modal
      isOpen={open}
      onClose={onCancel}
      title="Disqualify this lead"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button onClick={onConfirm} disabled={!comment.trim() || saving}>
            {saving ? "Saving…" : "Disqualify"}
          </Button>
        </>
      }
    >
      <p className="crm-help">A comment is required so the team knows why this lead is closed out.</p>
      <div className="crm-resizable-field">
        <label className="crm-field" htmlFor="disqualify-comment">Comment</label>
        <div className="crm-resizable-field-shell">
          <textarea
            id="disqualify-comment"
            value={comment}
            onChange={(event) => onCommentChange(event.target.value)}
            placeholder="Why is this lead disqualified?"
            required
          />
        </div>
      </div>
    </Modal>
  );
}
